<template>
  <helper-input-btn class="m-l-n-xs">
    <erp-input
        ref="input"
        class="sl-input"
        @input="__set"
        slot="input"
        simple-border
        v-model="description"
        :size="size"
        @keydown.enter="search"
        readonly
    >
      <u-popover v-if="this.findedData" hover :hover-delay="500" class="popover-user-profile" anchor="bottom middle"
                 self="top middle" :offset="[10, 10]">
        <div class="wrapper bg-white font-12">
          <div class="row">
            <div class="col m-r">ID: <strong>{{findedData.id}}</strong></div>
          </div>
          <div class="row m-t">
            <div class="col m-r">Nome: <strong>{{findedData.titulo}}</strong></div>
          </div>
          <div class="m-t">
            <e-btn @click="abrir" label="Acessar leilão" />
          </div>
        </div>
      </u-popover>
    </erp-input>
    <div class="erp-icon-float"><a @click="search"><i class="erp-icon search min"></i> </a></div>
  </helper-input-btn>
</template>

<script>
import InputMixin from '../../../../../reuse/input/mixin'
import {HelperInputBtn} from 'uloc-vue-plugin-erp'
import {UPopover} from 'uloc-vue'
import search from './SearchLeilao'
import leilaoWindow from "components/leiloes/windows/leilao"

export default {
  name: 'LeilaoInput',
  props: ['size'],
  mixins: [InputMixin],
  data () {
    return {
      findedData: this.findedDataObj
    }
  },
  watch: {
    findedData (v) {
      this.$emit('updateSelected', v)
    },
    findedDataObj (v) {
      this.adjust()
    }
  },
  mounted () {
    this.adjust()
  },
  components: {HelperInputBtn, UPopover},
  methods: {
    adjust () {
      if (this.findedDataObj) {
        this.description = this.findedDataObj.id + ' - ' + this.findedDataObj.titulo
      }
    },
    __updateInternal () {
      this.updateInternal((v) => v.id + ' - ' + v.nome)
    },
    search: search,
    leilaoWindow: leilaoWindow,
    abrir() {
      let router = this.$router || this.router
      let routeData = router.resolve({name: 'leiloes.show', params: {id: this.findedData.id}})
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
